import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  Empty,
  Input,
  PageHeader,
  Pagination,
  Row,
  Tooltip,
  Table,
} from "antd";

import { getRecoveries, downloadRecoveries } from "./actions";

import Loading from "../../components/Loading";
import ModalCompany from "../../components/ModalCompany";
import { maskCnpj, numberToReal } from "../../helpers/functions";
import { Sessao } from "../../helpers/Token";

const planoTeste = Sessao('planoTeste');

const ButtonGroup = Button.Group;

function Recovery() {
  const history = useHistory();
  const {
    data,
    isFetching,
    isInitialFetching,
    isPosting,
    paginacao,
  } = useSelector((state) => state.recoveries);
  const dispatch = useDispatch();

  const [filterOrder, setFilterOrder] = useState({ oRazaoSocial: 0 });
  const [filterSorter, setFilterSorter] = useState({});
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 20 });
  const [showModal, setModal] = useState(false);

  const moduloIcms = !!sessionStorage.getItem("icmsModule");
  const aceiteIcms = JSON.parse(localStorage.getItem("eRecuperadorAceito"));
  const icmsModule = sessionStorage.getItem("icmsModule");

  const initialRender = useCallback(() => {
    document.title = "e-Recuperador - Recuperações";

    if (moduloIcms && !aceiteIcms) {
      history.push("/contrato");
    } else {
      dispatch(
        getRecoveries({
          pagination,
          filter: { ...filterOrder, ...filterSorter },
        })
      );
    }
  }, [filterOrder, filterSorter, pagination]);

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  const baixarRelatorio = (isPDF) => {
    dispatch(downloadRecoveries(isPDF));
  };

  const handleClick = (item) => {
    const company = {
      Id: item.Empresa.Id,
      RazaoSocial: item.Empresa.RazaoSocial,
      Cnpj: item.Empresa.Cnpj,
      Uf: item.Empresa.Uf,
    };

    if (item.CompetenciaCadastradas) {
      sessionStorage.setItem("eRecuperadorActiveTabCompany", 4);
    } else {
      sessionStorage.setItem("eRecuperadorActiveTabCompany", 2);
    }
    sessionStorage.setItem("eRecuperadorCompany", JSON.stringify(company));
    history.push(`/empresa/${company.Cnpj}`);
  };

  const doFilterOrder = (pagination, filters, sorter) => {
    let order = sorter.order === "descend" ? 0 : 1;
    let field = sorter.field;

    if (field.includes(".")) {
      field = `o${field.split(".").pop()}`;
    }

    if (!!sorter.order) {
      setFilterOrder({ [field]: order });
    } else {
      setFilterOrder({});
    }
  };

  const handleSizeOptions = () => {
    let sizeOptions = ["10", "20", "50", "100"];

    sizeOptions = sizeOptions.filter((size) => {
      return (
        Number(size) * paginacao.PageNumber - paginacao.TotalItems <=
        Number(size)
      );
    });

    return sizeOptions;
  };

  const columns = [
    {
      title: "Empresa",
      dataIndex: "Empresa.RazaoSocial",
      width: 400,
      sorter: true,
      disabled: true,
    },
    {
      title: "CNPJ",
      dataIndex: "Empresa.Cnpj",
      width: 150,
      sorter: true,
      render: (value) => maskCnpj(value),
    },
    {
      title: "Competências Cadastradas",
      dataIndex: "CompetenciaCadastradas",
      align: "center",
      render: (value) => (planoTeste && parseInt(value) >= 2) ? '2' : value,
    },
    {
      title: "Competências Auditadas",
      dataIndex: "CompetenciaAuditadas",
      align: "center",
    },
    {
      title: "Crédito Apurado PIS/COFINS",
      dataIndex: "CreditoApurado",
      align: "center",
      render: (value) => numberToReal(value),
    },
    {
      align: "center",
      width: 55,
      render: (value, record) => (
        <Tooltip title="Visualizar">
          <Button
            type="primary"
            icon="eye"
            onClick={() => handleClick(record)}
          />
        </Tooltip>
      ),
    },
  ];

  if (icmsModule) {
    columns.splice(5, 0, {
      title: "Crédito Apurado ICMS",
      dataIndex: "CreditoApuradoIcms",
      align: "center",
      render: (value) => numberToReal(value),
    });
  }

  const propsTable = {
    columns,
    className: "ant-table--custom noselect",
    dataSource: data,
    pagination: false,
    loading: isFetching,
    rowKey: (record) => record.Empresa.Id,
    scroll: { y: "calc(100vh - 300px)", x: "1050px" },
    onChange: doFilterOrder,
  };

  const propsPagination = {
    className: "mt-2",
    disabled: isFetching,
    pageSizeOptions: handleSizeOptions(),
    pageSize: paginacao.PageSize,
    total: paginacao.TotalItems,
    showTotal: (count, range) => `${range[0]}-${range[1]} de ${count} itens`,
    onChange: (page, pageSize) => {
      return setPagination((prev) => ({ ...prev, pageNumber: page }));
    },
    onShowSizeChange: (current, size) => {
      return setPagination((prev) => ({ ...prev, pageSize: size }));
    },
    showSizeChanger: true,
    hideOnSinglePage: true,
  };
  
  return (
    <>
      {isInitialFetching && <Loading />}

      {!!data.length && (
        <>
          <PageHeader
            backIcon={null}
            title={
              icmsModule
                ? "SEGREGAÇÃO DE RECEITAS – PIS/COFINS E ICMS"
                : "APURAÇÃO DE CRÉDITO - PIS/COFINS"
            }
          />

          <div className="px-2 pb-5">
            <Row gutter={16}>
              <Col xs={24} lg={14} xxl={16} className="mb-2">
                <ButtonGroup>
                  <Button
                    type="primary"
                    icon="file-pdf"
                    loading={isPosting}
                    onClick={() => baixarRelatorio(true)}
                  >
                    Exportar PDF
                  </Button>

                  <Button
                    type="primary"
                    icon="file-excel"
                    loading={isPosting}
                    onClick={() => baixarRelatorio(false)}
                  >
                    Exportar Excel
                  </Button>
                </ButtonGroup>
              </Col>

              <Col xs={24} lg={10} xxl={8} className="mb-2">
                <Input.Search
                  placeholder="Buscar por Razão Social ou CNPJ"
                  onSearch={(value) => {
                    return setFilterSorter((prev) => ({
                      ...prev,
                      sRazao_socialOuCNPJ: value,
                    }));
                  }}
                />
              </Col>
            </Row>

            <Table {...propsTable} />

            <Pagination {...propsPagination} />
          </div>
        </>
      )}

      {!data.length && (
        <>
          <ModalCompany
            visible={showModal}
            closeModal={() => setModal(false)}
          />
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={`Nenhuma empresa encontrada para realizar o processo de ${
              moduloIcms ? "segregação de receitas" : "recuperação"
            }`}
          >
            <Button type="primary" onClick={() => setModal(true)}>
              {`NOVO PROCESSO DE ${
                moduloIcms ? "SEGREGAÇÃO DE RECEITAS" : "RECUPERAÇÃO"
              }`}
            </Button>
          </Empty>
        </>
      )}
    </>
  );
}

export default Recovery;
